export default __webpack_public_path__ + "static/media/p2023-47.1d45de13.jpeg";